/**
 * Stable React keys for `File` objects.
 *
 * Upload lists were keyed by array index. That is fine until the list changes:
 * removing the files that just uploaded shifts every later index, so React reuses
 * the wrong component instances, thumbnails get re-mounted and the grid visibly
 * flickers at exactly the moment the user is looking at it.
 *
 * Name plus size plus timestamp is not enough - a user can pick the same file
 * twice - so identity is tracked per object. A `WeakMap` means an id costs nothing
 * once the file is dropped from state.
 */

const fileKeys = new WeakMap<File, string>();
let nextId = 0;

export const getFileKey = (file: File): string => {
  const existing = fileKeys.get(file);
  if (existing) return existing;

  nextId += 1;
  const key = `file-${nextId}`;
  fileKeys.set(file, key);
  return key;
};
